module.exports = __webpack_public_path__ + "img/bread-account-center.b7e0b376.png";